import slugify from 'slugify';

const SLUGIFY_OPTS = {
  strict: true,
};

export const slugifyName = (name: string) =>
  slugify(name.toLowerCase(), SLUGIFY_OPTS);

const SLUG_SEPARATOR = '-';

const trimSlug = (name: string, limitChars: number) => {
  if (name.length <= limitChars) {
    return name;
  }

  name = name.substring(0, limitChars);
  if (name.lastIndexOf(SLUG_SEPARATOR) === -1) {
    return name;
  }
  return name.substring(0, name.lastIndexOf(SLUG_SEPARATOR));
};

export const slugifyForURL = (name: string, limitChars: number) => {
  let parts = name.split(' ').filter((part) => part.length > 0);
  parts = parts.map((part) => slugifyName(part).trim());

  const slugifiedName = parts.join(SLUG_SEPARATOR);

  if (limitChars) {
    return trimSlug(slugifiedName, limitChars);
  }

  return slugifiedName;
};
